import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import Pagination from "react-bootstrap/Pagination";
import Table from "react-bootstrap/Table";
import { myId } from "../Pages/ResultTable";
import { proxyServer } from '../../../assets/constantes';
import { Form } from 'react-bootstrap';

const initDataTable = {
  actualPage: 1,
  totalPages: 1,
  data: [],
  rowsPerPage: 10,
};

const TableMonitorUsers = () => {
  const [dataTable, setDataTable] = useState(initDataTable);
  const [dataComplete, setDataComplete] = useState([]);
  useEffect(() => {
    initDataComplete();
  }, []);
  useEffect(() => {
    if (dataComplete.length > 0) {
      const totalPages = Math.ceil(
        dataComplete?.length / dataTable.rowsPerPage
      );
      setDataTable({
        ...dataTable,
        totalPages,
        data: dataComplete.slice(0, dataTable.rowsPerPage),
      });
    }
  }, [dataComplete]);



  const initDataComplete = async () => {
    try {
      const res = await axios.get(`${proxyServer}api/getAllMonitorUsers`);
      const data = res?.data?.result;
      if (data){
        setDataComplete(data);
      }else{
        setDataComplete([]);
        console.log("Error al cargar los datos");
      }
      
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeRowsPerPage = (e) => {
    //console.log("e.target.value:...", e.target.value);
    const rowsPerPage = Number(e.target.value);
    const totalPages = Math.ceil(dataComplete?.length / rowsPerPage);
    const initReg = dataTable.actualPage * rowsPerPage - rowsPerPage;
    const endReg = dataTable.actualPage * rowsPerPage;
    setDataTable({
      ...dataTable,
      totalPages,
      rowsPerPage,
      data: dataComplete.slice(initReg, endReg),
    });
  };
  const tableHeaders=[
    "User",
    "Estatus",
    "Role",
    "Paises"
  ];

  return (
    <div>
      {dataComplete.length===0?<div className="alert alert-warning">No hay datos para mostrar:</div>:
<div className="">
      <div className="fs-3 m-2 d-flex  border bg-light rounded w-100">
        <div className="text-end w-50 ">Monitor Users List:</div>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
          {tableHeaders.map((header) => (
            <th
              key={myId()}
              className="bg-dark text-white opacity-75"
            >
              {header}
            </th>
          ))}
            
          </tr>
        </thead>
        <tbody>
          {dataTable.data.map((item) => (
            <tr key={myId()}>
              <td>{item.user}</td>
              <td>{item.estatus}</td>
              <td>{item.role}</td>
              <td>{item.paises.join(',')}</td> 
            </tr>
          ))}
        </tbody>
      </Table>
      <h3 className="text-center border my-2 py-2 bg-light fs-6">Número de Registros: {dataComplete.length}</h3>
      <Pagination className=" d-flex justify-content-center align-items-center w-100">
        <Pagination.First
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: 1,
              data: dataComplete.slice(0, dataTable.rowsPerPage),
            });
          }}
        />
        <Pagination.Prev
          onClick={() => {
            if (dataTable.actualPage === 1) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage - 1,
              data: dataComplete.slice(
                (dataTable.actualPage - 2) * dataTable.rowsPerPage,
                (dataTable.actualPage - 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Item active>{dataTable.actualPage}</Pagination.Item>
        <Pagination.Ellipsis />
        <Pagination.Item>{dataTable.totalPages}</Pagination.Item>
        <Pagination.Next
          onClick={() => {
            if (dataTable.actualPage === dataTable.totalPages) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage + 1,
              data: dataComplete.slice(
                dataTable.actualPage * dataTable.rowsPerPage,
                (dataTable.actualPage + 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Last
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: dataTable.totalPages,
              data: dataComplete.slice(
                (dataTable.totalPages - 1) * dataTable.rowsPerPage,
                dataTable.totalPages * dataTable.rowsPerPage
              ),
            });
          }}
        />

        <Form.Select
          style={{ width: "60px" }}
          className="m-1 p-1"
          name="rowsPerPage"
          onChange={handleChangeRowsPerPage}
          id=""
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
        </Form.Select>
      </Pagination>
    </div>
}

    </div>
  )
}

export default TableMonitorUsers